module.exports = __webpack_public_path__ + "static/media/devices.df8d03a9.png";